import { computed } from 'vue';

import { GlobalState } from '@/global';
import { isMissingOutboundCallerId } from '@/modules/talk/helpers/number-routing';
import { DataCache } from '@/shared/data/cache';
import { hasPermission } from '@/shared/helpers/permissions.helpers';

/**
 * How many live extensions can't place an outgoing call because no caller ID is set on them.
 *
 * Severe — the extension looks configured and works for internal calls, but every external call it
 * tries fails — yet it still raises the attention dot rather than the red marker: red is reserved
 * for emergency calling, so that one signal can't be diluted.
 *
 * Same shape as its siblings: gated on tenant-admin + Talk, reading the shared `talkExtensions`
 * entry lazily so a nav marker never provokes the request on its own.
 */
export const talkExtensionsMissingCallerIdCount = computed<number>(() => {
    if (!GlobalState.tenant.value?.isAdmin || !hasPermission('talk')) return 0;
    const extensions = DataCache.getLazyRef('talkExtensions').value;
    return extensions ? extensions.filter(e => !e.deletedAt && isMissingOutboundCallerId(e)).length : 0;
});

/** Returns the shared count, kicking the (gated, deduped) load if it hasn't run yet. */
export function useTalkExtensionsMissingCallerId() {
    if (GlobalState.tenant.value?.isAdmin && hasPermission('talk')) DataCache.getRef('talkExtensions');
    return talkExtensionsMissingCallerIdCount;
}
